import type { IconName } from '@/assets/icons/icons'

export interface IButtonInfo {
  title: string
  iconName: IconName
  clickHandler: () => void
}

export const automationSidebarLayoutScrollbarId = 'automation-sidebar-layout-scrollbar' as const
